var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"publicidad-overlay"},[(_vm.lanzamientoAbierto && _vm.lanzamiento)?_c('LanzamientoDialog',{attrs:{"campania":_vm.lanzamiento},on:{"cerrado":function($event){_vm.lanzamientoAbierto = false}}}):_vm._e(),(_vm.mostrarBarraPos)?_c('BarraPos',{attrs:{"campania":_vm.barraPos}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }